import useAuth from '../hooks/useAuth';

const ROLE_NAME = ['ResiView', 'Admin', 'Employee', 'Homeowner', 'Resident'];
const ADMIN_ACCESS_MODULE = ['admin', 'flip'];
const SERVICE_PRO = ['ResiView', 'Employee'];
// Residents (co-homeowners) share the homeowner experience.
const HOMEOWNER = ['Admin', 'Homeowner', 'Resident'];
const SERVICE_PRO_ACCESS_PAGE = ['Admin', 'ResiView', 'Employee'];

export function getRoles() {
  return ROLE_NAME;
}

export function servicePro() {
  return SERVICE_PRO;
}

export function homeowner() {
  return HOMEOWNER;
}

export function serviceProAccess() {
  return SERVICE_PRO_ACCESS_PAGE;
}

export function isAccessModule(title = '') {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useAuth();
  return user.role === 'Admin' || !ADMIN_ACCESS_MODULE.includes(title);
}

export function isAccessModulePage(page) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useAuth();
  return user.role !== 'Admin' && page;
}

// A resident (co-homeowner) can do everything a homeowner can except the move
// workflow and deleting anything (card 123).
export function isResident() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useAuth();
  return user?.role === 'Resident';
}

export function canDelete() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useAuth();
  return user?.role !== 'Resident';
}

export function isAuthProviderLocal(value) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useAuth();
  return value === 'change_password' ? user.authProvider === 'password' : true;
}
